import { z } from 'zod';

export type OnboardingConfig = {
  BusinessName?: string;
  PrimaryColor?: string;
  AccentColor?: string;
  SecondaryColor?: string;
  BusinessLogoPath?: string;
};

export function extractBrandingData(cfg: OnboardingConfig): { logoUrl: string | null; brandColor: string | null } {
  const brandColor = cfg?.PrimaryColor ?? cfg?.AccentColor ?? cfg?.SecondaryColor ?? null;
  const url = cfg?.BusinessLogoPath?.trim() ?? null;
  const logoUrl = url && url.startsWith('http') ? url : null;
  return { logoUrl, brandColor };
}

export const OnboardingConfigSchema = z.object({
  BusinessName: z.string().optional(),
  PrimaryColor: z.string().optional(),
  AccentColor: z.string().optional(),
  SecondaryColor: z.string().optional(),
  BusinessLogoPath: z.string().url().optional(),
});
